
const dev = {
    apiGateway: {
        env: 'dev',
        API_SERVER_URL: process.env.REACT_APP_API_SERVER_URL || "https://newapi.lasu.co.il",
    },
    PATH_BASE: process.env.REACT_APP_PATH_BASE || ""
};

const int = {
    apiGateway: {
        env: 'int',
        API_SERVER_URL: process.env.REACT_APP_API_SERVER_URL || "",
    },
    PATH_BASE: process.env.REACT_APP_PATH_BASE || "",
};

const prod = {
    apiGateway: {
        env: 'prod',
        API_SERVER_URL: process.env.REACT_APP_API_SERVER_URL || "",
    },
    PATH_BASE: process.env.REACT_APP_PATH_BASE || "",
};

let config = dev;
if (process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE.trim() === 'production') {
    config = prod;
}

else if (process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE.trim() === 'int') {
    config = int;
}

export default {
    APP_VERSION: 0.1,
    ...config
}